import React, { useState, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.css";
import { Table, Modal, Button, notification, Input, Switch } from "antd";
import { Link } from "react-router-dom";
import { baseApiUrl } from "../../services/api";

import axios from "axios";
import { jwtDecode } from "jwt-decode"; // Importation corrigée
import { ca } from "date-fns/locale";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

const Projet = () => {
  const [titre, setTitre] = useState("");
  const [image, setImage] = useState("");
  const [description, setDescription] = useState("");
  const [document, setDocument] = useState(null);

  const [video, setVideo] = useState("");
  const [origineMission, setOrigineMission] = useState("");
  const [caractereInnovant, setCaractereInnovant] = useState("");
  const [descriptionTechnique, setDescriptionTechnique] = useState("");
  const [besoinExpose, setBesoinExpose] = useState("");
  const [moyensPourReussir, setMoyensPourReussir] = useState("");
  const [critereReussite, setCritereReussite] = useState("");
  const [besoinsEventuels, setBesoinsEventuels] = useState("");

  const [calendrierFin, setCalendrierFin] = useState("");
  const [calendrierDebut, setCalendrierDebut] = useState("");

  const [step, setStep] = useState(1);

  const [categorieId, setCategorieId] = useState("");
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [projetId, setProjetId] = useState(null);
  const [sviewingProjet, setSviewingProjet] = useState("");
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteProjet, setDeleteProjet] = useState(null);

  const [projetToDelete, setProjetToDelete] = useState(null);
  const showDeleteModal = (id) => {
    setProjetToDelete(id);
    setIsDeleteModalVisible(true);
  };

  const handleCancelDelete = () => {
    setIsDeleteModalVisible(false);
    setProjetToDelete(null);
  };
  const confirmDelete = async () => {
    if (projetToDelete) {
      await handleDelete(projetToDelete);
      setIsDeleteModalVisible(false);
    }


  };

  const handleDeleteConfirm = (projet) => {
    setDeleteProjet(projet);
    setDeleteModalVisible(true);
  };
  const [projets, setProjets] = useState([]);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingProjet, setEditingProjet] = useState(null);
  const [viewingProjet, setViewingProjet] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategorie, setSelectedCategorie] = useState(null);
  // const imageUrl = projets.images
  //   ? `http://localhost:8081/api/images/${projets.images}`
  //   : "default-image.jpg";
  const [currentUser, setCurrentUser] = useState(null); // État pour stocker l'utilisateur

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0]; // Récupérer le premier fichier sélectionné
    if (file) {
      setImage(file); // Mettre à jour l'état avec l'image sélectionnée
    }
  };

  // const truncateText = (text, wordLimit) => {
  //   const words = text.split(" ");
  //   if (words.length > wordLimit) {
  //     return words.slice(0, wordLimit).join(" ") + "..."; // Tronque et ajoute "..."
  //   }
  //   return text; // Retourne le texte sans changement si le nombre de mots est inférieur à la limite
  // };
  const truncateText = (text, wordLimit) => {
    if (typeof text !== "undefined" && text !== null) {
      const words = text.split(" ");
      if (words.length > wordLimit) {
        return words.slice(0, wordLimit).join(" ") + "..."; // Tronque et ajoute "..."
      }
      return text; // Retourne le texte sans changement si le nombre de mots est inférieur à la limite
    } else {
      return ""; // Retourne une chaîne vide si text est undefined ou null
    }
  };

  const fetchProjets = async () => {
    try {
      const response = await baseApiUrl.get("/projet/liste");

      // Vérification du statut HTTP de la réponse
      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      // Les données sont accessibles directement via `response.data` avec axios
      const data = response.data;

      if (!data || data.length === 0) {
        console.warn("Aucun projet trouvé.");
      }

      // Met à jour l'état avec les projets récupérés
      setProjets(data);
    } catch (error) {
      console.error(
        "Erreur lors du chargement des projets:",
        error.message || error
      );
      openNotificationWithIcon(
        "error",
        "Erreur lors de la récupération des projets."
      );
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await baseApiUrl.get(
        "/categorie/liste"
      );

      // Transformer les données pour correspondre au format des options de <Select>
      const options = response.data.map((category) => ({
        value: category.id, // Utiliser l'identifiant ou un autre attribut unique de la catégorie
        label: category.nom, // Utiliser le nom ou un autre attribut descriptif de la catégorie
      }));

      setCategoriesOptions(options);
    } catch (error) {
      console.error("Erreur lors de la récupération des catégories:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchProjets();
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token"); // Assurez-vous que c'est le bon nom de clé
    if (token) {
      try {
        const decoded = jwtDecode(token); // Utilisation de jwtDecode
        setCurrentUser(decoded); // Décodez et stockez les informations de l'utilisateur
        console.log("Utilisateur connecté:", decoded); // Vérifiez les informations de l'utilisateur
      } catch (error) {
        console.error("Erreur lors du décodage du token:", error);
      }
    } else {
      console.warn("Aucun token trouvé dans localStorage."); // Avertir si aucun token n'est trouvé
    }

  }, []);

  const handleAddProjet = async (e) => {
    e.preventDefault();

    if (!titre) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs.");
      return;
    }

    try {
      const formData = new FormData();

      const projetData = {
        titre,
        origineMission,
        caractereInnovant,
        descriptionTechnique,
        besoinExpose,
        calendrierDebut,
        calendrierFin,
        moyensPourReussir,
        critereReussite,
        besoinsEventuels,
        categorieId: selectedCategorie
      };

      formData.append("projet", new Blob([JSON.stringify(projetData)], {
        type: "application/json"
      }));

      if (document) {
        formData.append("document", document);
      }
      if (image) {
        formData.append("image", image);
      }
      if (video) {
        formData.append("video", video);
      }

      console.log("Données du projet:", projetData);

      console.log("Données du date:", formData);


      // ✅ Correction de l'appel API avec Axios
      const response = await baseApiUrl.post("/projet/create", formData);

      // ✅ Récupération correcte des données
      const newProjet = response.data;

      console.log("Réponse API:", newProjet);

      setProjets([newProjet, ...projets]);

      console.log("Réponse API:", newProjet);

      // ✅ Notification de succès
      openNotificationWithIcon("success", "Projet ajouté avec succès.");
      fetchProjets();
    } catch (error) {
      openNotificationWithIcon("error", "Erreur lors de l'ajout du projet.");
      console.error("Erreur détectée:", error.response?.data || error.message || error);
    }

    resetForm();
  };


  const handleEditProjets = async (e) => {
    e.preventDefault();

    if (!editingProjet) {
      openNotificationWithIcon(
        "error",
        "Aucun projet sélectionné pour la modification."
      );
      return;
    }

    if (!titre) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        openNotificationWithIcon(
          "error",
          "Utilisateur non authentifié. Veuillez vous connecter."
        );
        return;
      }

      const projetData = {
        titre,
        description,
        categorieId: selectedCategorie.id,
        image,

        origineMission,
        caractereInnovant,
        descriptionTechnique,
        besoinExpose,
        calendrierDebut,
        calendrierFin,
        moyensPourReussir,
        critereReussite,
        besoinsEventuels,
      };

      const response = await baseApiUrl.put(
        `/projet/update/${editingProjet.id}`, projetData);

      if (!response.ok)
        throw new Error("Erreur lors de la modification du projet");

      // Assurez-vous que la réponse est valide avant de tenter de la parser
      if (response.status === 200) {
        const updatedProjet = await response.text();
        setProjets(
          projets.map((proj) =>
            proj.id === updatedProjet.id ? updatedProjet : proj
          )
        );
      } else {
        throw new Error(`Erreur inattendue: ${response.status}`);
      }

      openNotificationWithIcon("success", "Projet modifié avec succès.");
      fetchProjets();
    } catch (error) {
      openNotificationWithIcon(
        "error",
        "Erreur lors de la modification du projet."
      );
      console.error("Erreur détectée:", error);
    }

    resetForm();
  };


  const handleEditProjet = async (e) => {
    e.preventDefault();

    // Vérification si un projet est sélectionné pour la modification
    if (!editingProjet) {
      openNotificationWithIcon("error", "Aucun projet sélectionné pour la modification.");
      return;
    }

    // Vérification que tous les champs nécessaires sont remplis
    if (!titre) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs obligatoires.");
      return;
    }

    // Préparation des données du projet
    const projetData = {
      titre,
      description,
      categorieId: selectedCategorie.id,
      image,
      origineMission,
      caractereInnovant,
      descriptionTechnique,
      besoinExpose,
      calendrierDebut,
      calendrierFin,
      moyensPourReussir,
      critereReussite,
      besoinsEventuels,
    };

    // Création de FormData pour les requêtes multipart/form-data
    const formData = new FormData();
    formData.append("Projet", new Blob([JSON.stringify(projetData)], { type: "application/json" }));


    if (image) formData.append("image", image); // Ajout de l'image si elle existe
    if (document) formData.append("document", document); // Ajout du document si nécessaire

    try {
      // Envoi de la requête pour modifier le projet
      const response = await baseApiUrl.put(`/projet/update/${editingProjet.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      // Mise à jour de la liste des projets
      const updatedProjet = await response.data;
      console.log("Projet mis à jour:", updatedProjet);

      setProjets(
        projets.map((projet) => (projet.id === updatedProjet.id ? updatedProjet : projet))
      );

      openNotificationWithIcon("success", "Projet modifié avec succès.");
    } catch (error) {
      console.error("Erreur lors de la modification du projet:", error);
      openNotificationWithIcon("error", "Erreur lors de la modification du projet.");
    }

    // Réinitialisation du formulaire après l'envoi
    resetForm();
  };



  const handleUpdateProjet = async (e) => {
    e.preventDefault();

    if (!titre) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs.");
      return;
    }

    try {
      const formData = new FormData();
      const projetData = {
        titre,
        origineMission,
        caractereInnovant,
        descriptionTechnique,
        besoinExpose,
        calendrierDebut,
        calendrierFin,
        moyensPourReussir,
        critereReussite,
        besoinsEventuels,
        categorieId: selectedCategorie,
      };

      // Ajout des données JSON du projet dans formData
      formData.append("projet", new Blob([JSON.stringify(projetData)], { type: "application/json" }));

      // Ajout des fichiers si présents
      if (document) {
        formData.append("document", document);
      }
      if (image) {
        formData.append("image", image);
      }
      if (video) {
        formData.append("video", video);
      }

      console.log("Données du projet:", projetData);
      console.log("FormData:", formData);

      // ✅ Appel à l'API pour mettre à jour le projet
      const response = await baseApiUrl.put(`/projet/update/${projetId}`, formData);

      // ✅ Récupération des données mises à jour
      const updatedProjet = response.data;
      console.log("Réponse API (mise à jour):", updatedProjet);

      // ✅ Mettre à jour l'état des projets avec le projet mis à jour
      setProjets((prevProjets) =>
        prevProjets.map((projet) => (projet.id === updatedProjet.id ? updatedProjet : projet))
      );

      // ✅ Notification de succès
      openNotificationWithIcon("success", "Projet mis à jour avec succès.");

      // ✅ Récupérer la liste des projets à jour
      fetchProjets();
    } catch (error) {
      openNotificationWithIcon("error", "Erreur lors de la mise à jour du projet.");
      console.error("Erreur détectée:", error.response?.data || error.message || error);
    }

    // Réinitialisation du formulaire après l'update
    resetForm();
  };


  const handleEdit = (projet) => {
    setViewingProjet(projet);
    setEditingProjet(projet);
    setTitre(projet.titre);
    setOrigineMission(projet.origineMission);
    setCaractereInnovant(projet.caractereInnovant);
    setDescriptionTechnique(projet.descriptionTechnique);
    setBesoinExpose(projet.besoinExpose);
    setMoyensPourReussir(projet.moyensPourReussir);
    setCritereReussite(projet.critereReussite);
    setBesoinsEventuels(projet.besoinsEventuels);
    setSelectedCategorie(projet.categorieId);
    setImage(projet.image);
    setDocument(projet.document);
    setCalendrierDebut(projet.calendrierDebut);
    setCalendrierFin(projet.calendrierFin);
    setIsEditMode(true);
    setIsEditModalVisible(true);

    setIsEditModalVisible(true);
  };


  const handleDelete = async (idProjet) => {
    try {
      const response = await baseApiUrl.delete(`/projet/delete/${idProjet}`);

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      setProjets(projets.filter((projet) => projet.id !== idProjet));
      setDeleteModalVisible(false);
      setDeleteProjet(null);
      openNotificationWithIcon("success", "Projet supprimé avec succès.");
    } catch (error) {
      openNotificationWithIcon(
        "error",
        "Erreur lors de la suppression du projet."
      );
      console.error("Erreur:", error);
    }
  };


  const handleStatusChange = async (key, value) => {
    // Vérifiez que key (ID du projet) est bien défini
    console.log("ID du projet:", key); // Assurez-vous que key n'est pas undefined

    if (key === undefined) {
      console.error("ID du projet est manquant !");
      return;
    }

    try {
      // Appel à l'API pour activer ou désactiver le projet
      const response = await baseApiUrl.put(
        `/projet/activeDesactive/${key}`,
        {
          actif: value, // Passez la valeur de l'état actif
        }
      );

      // Vous pouvez afficher la réponse de l'API si nécessaire
      console.log(response.data);
      fetchProjets(); // Réponse de l'API, vous pouvez l'utiliser pour afficher un message de succès
    } catch (error) {
      console.error("Erreur lors de la mise à jour du projet:", error); // En cas d'erreur, vous pouvez choisir de rétablir l'état précédent ou afficher un message d'erreur
      // Rétablir l'état précédent en cas d'erreur
      const revertedData = data.map((item) => {
        if (item.id === key) {
          return { ...item, actif: !value };
        }
        return item;
      });
      setData(revertedData);

    }
  };

  const resetForm = () => {
    setStep(1);
    setIsEditMode(false);
    setEditingProjet(null);
    setIsAddModalVisible(false);
    setIsEditModalVisible(false);
    setIsViewModalVisible(false);
    setTitre("");
    setOrigineMission("");
    setCaractereInnovant("");
    setDescriptionTechnique("");
    setBesoinExpose("");
    setMoyensPourReussir("");
    setCritereReussite("");
    setBesoinsEventuels("");
    setSelectedCategorie("");
    setImage("");
    setDocument("");
    setCalendrierFin("");
    setCalendrierDebut("");
    setIsEditMode(false);
    setEditingProjet(null);
    setIsAddModalVisible(false);
    setIsEditModalVisible(false);
    // setIsViewModalVisible(false);
  };

  const handleView = (projet) => {
    setViewingProjet(projet);
    setIsViewModalVisible(true);
  };

  const handleNext = () => {
    setStep(step + 1);
  };

  const handlePrevious = () => {
    setStep(step - 1);
  };

  // const filteredProjets = projets.filter(
  //   (projet) =>
  //     projet.titre &&
  //     projet.titre.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  const filteredProjets = projets.filter((projet) => {
    const titre = projet.titre && projet.titre.toLowerCase().includes(searchTerm.toLowerCase());
    const descriptionTechnique = projet.descriptionTechnique && projet.descriptionTechnique.toLowerCase().includes(searchTerm.toLowerCase());
    const origineMission = projet.origineMission && projet.origineMission.toLowerCase().includes(searchTerm.toLowerCase());

    return titre || descriptionTechnique || origineMission;
  });


  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-auto">
                <h3 className="page-title">Projets</h3>
                <div className="top-nav-search">
                  <input
                    className="form-control"
                    placeholder="Rechercher par nom"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              {/* <div className="col-sm-5 col">
                <Button
                  type="primary"
                  onClick={() => {
                    resetForm();
                    setIsAddModalVisible(true);
                  }}
                  className="float-end mt-2"
                >
                  Ajouter un projet
                </Button>
              </div> */}
              <div className="col-sm-5 col">
                <Button
                type="success"
                  onClick={() => {
                    resetForm();
                    setIsAddModalVisible(true);
                  }} className="float-end mt-2 btn-success"
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" /> {/* Icône ajoutée ici */}
                  Ajouter
                </Button>
              </div>
            </div>
          </div>

          <Table
            rowKey="id"
            columns={[
              {
                title: "Titre",
                dataIndex: "titre",
                key: "titre",
                render: (text) => truncateText(text, 6), // Tronque le titre à 5 mots
              },
              {
                title: "Origine de la mission",
                dataIndex: "origineMission",
                key: "origineMission",
                render: (text) => truncateText(text, 6), // Tronque le titre à 5 mots
              },
              {
                title: "Description techique",
                dataIndex: "descriptionTechnique",
                key: "descriptionTechnique",
                render: (text) => truncateText(text, 6), // Tronque la description à 10 mots
              },

              {
                title: "Etat",
                dataIndex: "actif",
                key: "actif",
                render: (actif, record) => (
                  <Switch
                    checked={actif}
                    onChange={(checked) =>
                      handleStatusChange(record.id, checked)
                    }
                  />
                ),
              },

              {
                title: "Image",
                dataIndex: "image",
                key: "image",
                render: (imageName) => {
                  // Définir le chemin complet de l'image
                  const imageUrl =
                    baseApiUrl.defaults.baseURL + `/image/${imageName}`;
                  return (
                    <img
                      src={imageUrl}
                      alt="project"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  );
                },
              },
              {
                // title: "Actions",
                // key: "actions",
                render: (text, record) => (
                  <div className="text-end">
                    <Button
                      className="ms-2 btn btn-sm bg-success-light"
                      onClick={() => {
                        resetForm();
                        handleView(record);
                      }}
                    >
                      Voir
                    </Button>
                    <Button
                      className="ms-2 btn btn-sm bg-primary-light"
                      onClick={() => {
                        resetForm();
                        handleEdit(record);
                      }}
                    >
                      Modifier
                    </Button>

                    <Button
                      className="ms-2 btn btn-sm bg-danger-light"
                      onClick={() => handleDeleteConfirm(record)}
                    >
                      Supprimer
                    </Button>
                  </div>
                ),
              },
            ]}
            dataSource={filteredProjets}
          />

          {/* Modal d'ajout de projet */}
          <Modal
            title="Ajouter un projet"
            visible={isAddModalVisible}
            onCancel={() => setIsAddModalVisible(false)}
            width={800}
          >
            <form onSubmit={handleAddProjet}>
              {step === 1 && (
                <>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Titre du projet</label>
                        <input
                          type="text"
                          className="form-control"
                          value={titre}
                          onChange={(e) => setTitre(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Origine de la mission</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={origineMission}
                          onChange={(e) => setOrigineMission(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Caractère innovant</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={caractereInnovant}
                          onChange={(e) => setCaractereInnovant(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Description technique du projet</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={descriptionTechnique}
                          onChange={(e) =>
                            setDescriptionTechnique(e.target.value)
                          }
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Besoin exposé du projet</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={besoinExpose}
                          onChange={(e) => setBesoinExpose(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Les moyens pour réussir</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={moyensPourReussir}
                          onChange={(e) => setMoyensPourReussir(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleNext}
                  >
                    Suivant
                  </button>
                </>
              )}

              {step === 2 && (
                <>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Critères de réussite</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={critereReussite}
                          onChange={(e) => setCritereReussite(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Besoins éventuels</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={besoinsEventuels}
                          onChange={(e) => setBesoinsEventuels(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Domaine du projet</label>
                        <select
                          className="form-control"
                          value={selectedCategorie}
                          onChange={(e) => setSelectedCategorie(Number(e.target.value))}                        >
                          <option value="">Sélectionnez un domaine...</option>
                          {/* Valeur par défaut */}
                          {categoriesOptions.map((category) => (
                            <option key={category.value} value={category.value}>
                              {category.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Document du projet</label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) => setDocument(e.target.files[0])}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Image du projet</label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) => setImage(e.target.files[0])}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Date de début du projet</label>
                        <input
                          type="date"
                          className="form-control"
                          value={calendrierDebut}
                          onChange={(e) => setCalendrierDebut(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Date de fin du projet</label>
                        <input
                          type="date"
                          className="form-control"
                          value={calendrierFin}
                          onChange={(e) => setCalendrierFin(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handlePrevious}
                  >
                    Précédent
                  </button>

                  <button
                    type="submit"
                    className="btn btn-primary"

                  >
                    Créer
                  </button>
                </>
              )}
            </form>
          </Modal>



          <Modal
            title="Confirmer la suppression"
            visible={deleteModalVisible}
            onCancel={() => setDeleteModalVisible(false)}
            footer={[
              <Button key="back" onClick={() => setDeleteModalVisible(false)}>
                Annuler
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={() => handleDelete(deleteProjet.id)}
              >
                Supprimer
              </Button>,
            ]}
          >
            <p>
              Êtes-vous sûr de vouloir supprimer ce projet ? Cette action est
              irréversible.
            </p>
          </Modal>

          {/* Modal de modification de projet */}

          <Modal
            title="Modifier un projet"
            visible={isEditModalVisible}
            onCancel={() => setIsEditModalVisible(false)}
            width={800}
          >
            <form onSubmit={handleEditProjet}>
              {step === 1 && (
                <>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Titre du projet</label>
                        <input
                          type="text"
                          className="form-control"
                          value={titre}
                          onChange={(e) => setTitre(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Origine de la mission</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={origineMission}
                          onChange={(e) => {
                            setOrigineMission(e.target.value);
                          }} style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Caractère innovant</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={caractereInnovant}
                          onChange={(e) => setCaractereInnovant(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Description technique du projet</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={descriptionTechnique}
                          onChange={(e) =>
                            setDescriptionTechnique(e.target.value)
                          }
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Besoin exposé du projet</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={besoinExpose}
                          onChange={(e) => setBesoinExpose(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Les moyens pour réussir</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={moyensPourReussir}
                          onChange={(e) => setMoyensPourReussir(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleNext}
                  >
                    Suivant
                  </button>
                </>
              )}

              {step === 2 && (
                <>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Critères de réussite</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={critereReussite}
                          onChange={(e) => setCritereReussite(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Besoins éventuels</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={besoinsEventuels}
                          onChange={(e) => setBesoinsEventuels(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Domaine du projet</label>
                        <select
                          className="form-control"
                          value={selectedCategorie}
                          onChange={(e) => setSelectedCategorie(e.target.value)}
                        >
                          <option value="">Sélectionnez un domaine...</option>{" "}
                          {/* Valeur par défaut */}
                          {categoriesOptions.map((category) => (
                            <option key={category.id} value={category.id}>
                              {category.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Document du projet</label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) => setDocument(e.target.files[0])}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Image du projet</label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) => setImage(e.target.files[0])}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Date de début du projet</label>
                        <input
                          type="date"
                          className="form-control"
                          value={calendrierDebut}
                          onChange={(e) => setCalendrierDebut(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Date de fin du projet</label>
                        <input
                          type="date"
                          className="form-control"
                          value={calendrierFin}
                          onChange={(e) => setCalendrierFin(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handlePrevious}
                  >
                    Précédent
                  </button>

                  <button
                    type="submit"
                    className="btn btn-primary"

                  >
                    Modifier
                  </button>
                </>
              )}
            </form>
          </Modal>


          <Modal
            title="Info d'un projet"
            visible={isViewModalVisible}
            onCancel={() => setIsViewModalVisible(false)}
            width={900}
            footer={null}
          >
            {viewingProjet && (
              <div>
                <h4>{viewingProjet?.titre}</h4>

                <p><strong>Description Technique:</strong> {viewingProjet?.descriptionTechnique}</p>
                <p><strong>Origine Mission:</strong> {viewingProjet?.origineMission}</p>
                <p><strong>Caractère Innovant:</strong> {viewingProjet?.caractereInnovant}</p>
                <p><strong>Besoin Exposé:</strong> {viewingProjet?.besoinExpose}</p>
                <p><strong>Moyens pour Réussir:</strong> {viewingProjet?.moyensPourReussir}</p>
                <p><strong>Critère de Réussite:</strong> {viewingProjet?.critereReussite}</p>
                <p><strong>Besoins Éventuels:</strong> {viewingProjet?.besoinsEventuels}</p>

                <p><strong>Domaine:</strong> {viewingProjet?.categorieNom || "Non défini"}</p>

                {viewingProjet?.documentProjet && (
                  <p>
                    <strong>Document:</strong>
                    <a href="#" onClick={() => handleDownloadDocument(viewingProjet.documentProjet)}>
                      Télécharger le document
                    </a>
                  </p>
                )}

                {viewingProjet?.image && (
                  <div className="mt-3 mb-3">
                    <strong>Image du projet:</strong><br />
                    <img
                      src={viewingProjet.image}
                      alt="Image du projet"
                      style={{ maxWidth: "100%", maxHeight: "300px" }}
                    />
                  </div>
                )}

                <p><strong>Date de début:</strong> {viewingProjet?.calendrierDebut ? new Date(viewingProjet.calendrierDebut).toLocaleDateString() : "Non définie"}</p>
                <p><strong>Date de fin:</strong> {viewingProjet?.calendrierFin ? new Date(viewingProjet.calendrierFin).toLocaleDateString() : "Non définie"}</p>
                <p><strong>Création:</strong> {new Date(viewingProjet?.creationDate).toLocaleString()}</p>
              </div>
            )}
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Projet;
